import { useModal } from "@pulse/hooks/contextHooks";
import { ParticipantsList } from "../ParticipantsList";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ActionButton from "./ActionButton";
import { faUsers } from "@fortawesome/pro-regular-svg-icons";

export default function SeeParticipants({ surveyId }: { surveyId: number }) {
    const { openModal } = useModal();
    const { t } = useTranslation();
    return (
        <ActionButton
            label={t("responseOverview.viewParticipants")}
            onClick={() =>
                openModal({
                    children: <ParticipantsList surveyId={surveyId} />,
                    title: t("responseOverview.participantsListTitle"),
                })
            }
        >
            <FontAwesomeIcon icon={faUsers} size="xl" />
        </ActionButton>
    );
}
